<div class="col-12" *ngIf="selectedDepositType === ''">
  <div class="col-6 col-offset-3">

    <p-fieldset [legend]="'UPLOAD_COMPONENT.UPLOAD_NATURE' | translate">
      <div class="col-12" style="font-size: 1.3em">
        <div class="col-12">
          <div class="deposit-type-option">
          <p-radioButton name="depositType" [value]="DepositDepotExpressEnum.UNIT"
                         [label]="'UPLOAD_COMPONENT.EXPRESS_DEPOSIT_UNIT' | translate"
                         [(ngModel)]="selectedDepositType" inputId="depopt1" (onClick)="notifyTypeSelection()"></p-radioButton>
          </div>
        </div>
        <div class="col-12">
          <div class="deposit-type-option">
          <p-radioButton name="depositType" [value]="DepositDepotExpressEnum.MAILING"
                         [label]="'UPLOAD_COMPONENT.EXPRESS_DEPOSIT_MAILING' | translate"
                         [(ngModel)]="selectedDepositType" inputId="depopt2" (onClick)="notifyTypeSelection()"></p-radioButton>
          </div>
        </div>

        <div class="col-12">
          <div class="deposit-type-option">
          <p-radioButton name="depositType" [value]="DepositDepotExpressEnum.SPOOL"
                         [label]="'UPLOAD_COMPONENT.EXPRESS_DEPOSIT_SPOOL' | translate"
                         [(ngModel)]="selectedDepositType" inputId="depopt3" (onClick)="notifyTypeSelection()"></p-radioButton>
          </div>
        </div>

        <div class="col-12" *ngIf="isErlAuthorized === true">
          <div class="deposit-type-option">
            <p-radioButton name="depositType" [value]="DepositDepotExpressEnum.ERL"
                           [label]="'UPLOAD_COMPONENT.EXPRESS_DEPOSIT_ERL' | translate"
                           [(ngModel)]="selectedDepositType" inputId="depopt4" (onClick)="notifyTypeSelection()"></p-radioButton>
          </div>
        </div>
      </div>
    </p-fieldset>
  </div>
</div>
<div *ngIf="selectedDepositType === DepositDepotExpressEnum.MAILING">
  <app-express-mailing (modalDisplay)="closeExpressDialog($event)"></app-express-mailing>
</div>
<div *ngIf="selectedDepositType === DepositDepotExpressEnum.UNIT">
  <app-express-unit (modalDisplay)="closeExpressDialog($event)"></app-express-unit>
</div>
<div *ngIf="selectedDepositType === DepositDepotExpressEnum.SPOOL">
  <app-express-spool (modalDisplay)="closeExpressDialog($event)"></app-express-spool>
</div>
<div *ngIf="selectedDepositType === DepositDepotExpressEnum.ERL">
  <app-express-erl (modalDisplay)="closeExpressDialog($event)"></app-express-erl>
</div>
